import { render, staticRenderFns } from "./CustomOccupationSuggestedSkills.vue?vue&type=template&id=3503c0ea&scoped=true&"
import script from "./CustomOccupationSuggestedSkills.vue?vue&type=script&lang=js&"
export * from "./CustomOccupationSuggestedSkills.vue?vue&type=script&lang=js&"
import style0 from "./CustomOccupationSuggestedSkills.vue?vue&type=style&index=0&id=3503c0ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503c0ea",
  null
  
)

export default component.exports